import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=5d3d089e&scoped=true&"
import script from "./Index.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Index.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./Index.vue?vue&type=style&index=0&id=5d3d089e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3d089e",
  null
  
)

export default component.exports